import React, { Component } from "react";

export class ClientCard extends Component {
  render() {
    let client = this.props.data;
    return (
      <div className="card " style={{ marginBottom: "2rem" }}>
        <a
          href={client.href}
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none" }}
        >
          <div className="ui image">
            <img
              style={{ maxHeight: "300px" }}
              src={client.img}
              alt={"image for " + client.name}
            />
          </div>
        </a>
        <div className="content">
          <div className="header">{client.name}</div>
          <div className="content " style={{fontStyle: "italic", padding: ".5rem 0"}}><span>{client.location}</span></div>
          <div className=" content">{client.desc}</div>
          <br></br>
          <div className="content">{client.desc2}</div>
        </div>
        <div className=" content">
          <span className=""><strong></strong><em>{client.created}</em></span>
        </div>
      </div>
    );
  }
}

export default ClientCard;
